import React, { Component } from 'react';
import { Modal, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTh } from '@fortawesome/free-solid-svg-icons';

class ModalValidarLotes extends Component {

    render() {

        return (
            <Modal show={this.props.show} onHide={this.props.onClose} backdrop="static" size="xl" enforceFocus={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Artículos con Cantidades Diferentes por Lote</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="row">
                        <p>Se ha detectado inconsistencias entre la cantidad de lotes y cantidad de detalle de los siguientes artículos</p>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Lote</th>
                                        <th>Código</th>
                                        <th>Nombre</th>
                                        <th>Cantidad Despacho</th>
                                        <th>Cantidad Lotes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.props.rows && this.props.rows.length > 0 ?
                                            this.props.rows.map(row =>
                                                <tr key={row.Articulo_Id}>
                                                    <td>
                                                        <div className="btn-group">
                                                            <button className="btn btn-success"
                                                                onClick={(e) => { e.stopPropagation(); this.props.onClickLotes(row) }}
                                                                data-toggle="tooltip"
                                                                data-placement="bottom"
                                                                title="Aplica Lote"
                                                                style={{ backgroundColor: "#00a65a", color: "#fff" }}>
                                                                <FontAwesomeIcon icon={faTh} />
                                                            </button>
                                                        </div>
                                                    </td>
                                                    <td>{row.Articulo_Id}</td>
                                                    <td>{row.Articulo_Nombre}</td>
                                                    <td>{row.Detalle_Facturar}</td>
                                                    <td>{row.Cant_Lotes}</td>
                                                </tr>
                                            ) : null
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={this.props.onClose} title="Cerrar">Cerrar</button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ModalValidarLotes; 